const STORAGE_KEY =
  "monappliscore_guest_id";

const createRandomId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID ===
      "function"
  ) {
    return crypto
      .randomUUID()
      .replaceAll("-", "")
      .slice(0, 12);
  }

  return [
    Math.random()
      .toString(36)
      .slice(2, 8),
    Date.now()
      .toString(36)
      .slice(-6),
  ].join("");
};

const getConnectedUserId = (
  user
) => {
  return (
    user?.userId ||
    user?.id ||
    user?.user_id ||
    null
  );
};

export const getScoreboardSessionId = (
  user
) => {
  const connectedUserId =
    getConnectedUserId(user);

  if (connectedUserId) {
    return `u-${connectedUserId}`;
  }

  if (typeof window === "undefined") {
    return `g-${createRandomId()}`;
  }

  try {
    const storedId =
      window.localStorage.getItem(
        STORAGE_KEY
      );

    if (storedId) {
      return storedId;
    }

    const newId =
      `g-${createRandomId()}`;

    window.localStorage.setItem(
      STORAGE_KEY,
      newId
    );

    return newId;
  } catch {
    return `g-${createRandomId()}`;
  }
};